export default __webpack_public_path__ + "static/media/Poster.eba03c93.png";